module.exports = __webpack_public_path__ + "static/media/Imagem 38@2x.ad560553.png";